/**
 * EndAdornment Component
 * 
 * This component renders the end icon for autocomplete field based on conditions
 * 
 * */
import React from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import { DefaultChipDiv, DefaultChipSpan } from './AutoComplete.styled';  
import ChipComponent from 'src/common/refactoredComponents/chipComponent/index.jsx';
import CloseIcon from './CloseIcon.jsx';
import DownIcon from './DownIcon.jsx';

export default function EndAdornment(props) {
    const {
        value,
        height,
        disabled,
        onChange,
        onClose,
        isMobile,
        isFromShiptoAddress,
        isFromPhysician,
        isFromSurgery,
        isFromMazorCase,
        inputValue,
        classes
    }  = props;

    const showDefaultChip = (isFromShiptoAddress && (value?.defaultAddress))??false; 
    // const showCloseOrDownArrow = ((!isFromPhysician && isFromSurgery) || isFromMazorCase || 
    // (isFromShiptoAddress && inputValue && inputValue !== '' && !value?.defaultAddress )) ?? false;
    
    //----------showCloseOrDownArrow has to be checked for all the mentioned coditions----------
    return ( 
        showDefaultChip ? (
            <>
                <DefaultChipDiv
                    isMobile={isMobile} 
                    inputValue={inputValue}>
                    <DefaultChipSpan/>
                    <ChipComponent
                        height={'auto'}
                        label="Default"
                        color="#4F4F4F"
                        borderRadius="20px"
                        isFromAutoComplete={true}
                        desktopPadding={'5px'}
                        // classes={classes}
                    />
                </DefaultChipDiv>
            </>
        ):null);
}